const READABLE_NULL_VALUE = '-';
/**
 * Map null value to readable value.
 * @param {object | string | null } value Value
 * @returns {object | string}
 */
export function toReadableIfNull(value) {
  return value == null ? READABLE_NULL_VALUE : value;
}
